import PropTypes from 'prop-types'
import React from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'

import { useRecoilValue } from 'recoil'

import styled from '@emotion/styled'

import {
  Button,
  BUTTON_VARIANT_NEGATIVE,
  Spinner,
  Text,
  TEXT_VARIANT_BOLD,
  Thumb,
  ThumbContainer,
  ThumbContainerFooter,
  ThumbCustomOverlay,
  ThumbDefaultError,
  TruncateAndTooltip,
  Grid,
  GridCell,
  Flex
} from 'mailup-web-components'

import { thumbnailState } from '../recoil/state/results'
import ThumbImage from './ThumbImage'
import { TEMPLATE_TYPE_LOCAL } from 'Constants/index'
import { ActionMemoized } from './ActionMemo'

const StyledThumbContainer = styled(ThumbContainer)`
  overflow: unset !important;

  .e-thumb {
    overflow: hidden;
    border-radius: 6px 6px 0 0;
    > div {
      border-radius: 6px 6px 0 0;
    }
  }
`

const Overlay = ({ id, type }) => {
  const intl = useIntl()
  const history = useHistory()

  const handleClickButton = () => {
    const templateType = type === TEMPLATE_TYPE_LOCAL ? 'local' : 'centralized'
    history.push(`/messages/email/bee/new/${templateType}/${id}`)
  }

  return (
    <ThumbCustomOverlay>
      <Button kind={BUTTON_VARIANT_NEGATIVE} onClick={handleClickButton}>
        {intl.formatMessage({
          id: 'Load.Bee.TemplatesCreateEmail'
        })}
      </Button>
    </ThumbCustomOverlay>
  )
}

Overlay.propTypes = {
  id: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired
}

const Result = ({ id, title, type, actions }) => {
  const { loading, error } = useRecoilValue(thumbnailState(id))

  return (
    <StyledThumbContainer>
      <Thumb
        HoverComponent={Overlay}
        hoverComponentProps={{ id, type }}
        aspectRatio={640 / 768}
      >
        {loading && <Spinner />}
        {error && <ThumbDefaultError />}
        <ThumbImage id={id} />
      </Thumb>
      <ThumbContainerFooter>
        <Grid variant='small' cols={9}>
          <GridCell span={7}>
            <Flex display='block' padding='16px 0 16px 16px'>
              <Text variant={TEXT_VARIANT_BOLD} htmlElement='div'>
                <TruncateAndTooltip text={title} />
              </Text>
            </Flex>
          </GridCell>
          <GridCell span={2}>
            <Flex justifyContent='flex-end' padding='12px 16px 0 0'>
              <ActionMemoized actions={actions} id={id} type={type} />
            </Flex>
          </GridCell>
        </Grid>
      </ThumbContainerFooter>
    </StyledThumbContainer>
  )
}

Result.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  actions: PropTypes.array.isRequired
}

export default Result
